module.exports = __webpack_public_path__ + "img/11.8ca4e08c.png";